<template>
  <nav id="nav-main" :class="bgNav ? 'nav-menu-show' : null">
    <div class="nav">
      <div class="nav-holder">
        <div class="nav-icon" :class="show ? 'nav-icon-open' : null" @click="onHandleMenu">
          <div></div>
        </div>
        <!-- <button type="button" class="burger" @click="onHandleMenu">
          -
        </button>-->
        <router-link :to="path">
          <div class="logo">
            <img src="../../../assets/imgs/vivinho_branco.png" alt style="height: 50px;"/>
          </div>
        </router-link>
      </div>
      <div class="nav-options">
        <Btn class="item" @click.native="showModal(true)" title="Busca">
          <img src="@/assets/imgs/icon-menu-search.png" alt />
        </Btn>
        <BtnPopup class="item">
          <span>{{ufAtiva}}</span>
        </BtnPopup>
        <Btn class="item" v-if="getCanal" @click.native="$router.push('/tabela-de-preco')" title="Tabela de Preço">
          <img src="@/assets/imgs/icon-menu-filter.png" alt />
        </Btn>
        <Btn
          class="item"
          v-if="isVivoStore"
          @click.native="$router.push('/ranking-lojas')"
          title="Classificação de Lojas Próprias"
        >
          <img src="@/assets/imgs/icon-menu-report.png" alt />
        </Btn>
        <Btn
          class="item notify"
          v-if="isNotifyVisible"
          @click.native="showNotificacoes(true)"
          title="Notificação"
        >
          <div class="dot" v-if="showNotifyDot"></div>
          <img src="@/assets/imgs/icon-menu-notify.png" alt />
        </Btn>
        <Perfil class="item" />
         <!-- <AlterarVisao class="item" /> -->
      </div>
    </div>
    <transition appear @before-enter="beforeEnter" @enter="enter">
      <Menu v-show="show" :menu="items" />
    </transition>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import gsap, { TimelineMax } from 'gsap';
import env from '@/config/env';
import mixins from '@/helpers/mixins';
import Btn from './components/Button';
import BtnPopup from './components/ButtonPopup';
import Menu from './components/Menu';
import Perfil from '@/components/layout/header/Perfil.vue';
import AlterarVisao from '@/components/layout/header/AlterarVisao.vue';

export default {
  name: 'NavMain',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    path: {
      type: [String, Object],
      default: () => ({
        name: 'home',
      }),
      required: true,
    },
  },
  components: {
    Btn,
    BtnPopup,
    AlterarVisao,
    Menu,
    Perfil,
  },
  data: () => ({
    // Buttons States
    ownStore: false,
    // Page
    scrolled: false,
    show: true,
    menuToogle: null,
  }),
  computed: {
    ...mapGetters({
      showNotifyDot: 'notificacoes/showButton',
      showNotify: 'notificacoes/showNotify',
      showFalandoDeGente: 'notificacoes/showFalandoDeGente',
      ufAtiva: 'user/ufState',
    }),
    bgNav() {
      return this.show === true || this.scrolled === true ? true : false;
    },
    isNotifyVisible() {
      return ( this.showNotify || this.showFalandoDeGente ) && env.revista.canal === 6;
    },
    isVivoStore() {
      return env.revista.canal === 5;
    },
    getCanal(){
      const canal = localStorage.getItem('revista.canal');
      return canal != 7;
    }
  },
  methods: {
    ...mapActions({
      // Search
      showModal: 'modal/showModal',
      // Notify
      habilitaNotificacoes: 'notificacoes/enabledNotify',
      habilitaFalandoDeGente: 'notificacoes/enabledAcessoFalandoDeGente',
      showNotificacoes: 'notificacoes/showNotificacoes',
      existeNotificacao: 'notificacoes/existeNotificacao',
      existeFalandoDeGente: 'notificacoes/existeFalandoDeGente',
    }),
    handleScroll() {
      const scrolled = window.scrollY > 40;
      this.scrolled = scrolled;
      this.show = scrolled;
    },
    onHandleMenu() {
      this.show = !this.show;
    },
    beforeEnter(el) {
      el.style.opacity = 0;
      el.style.transform = 'translate(-50, 0)';
    },
    enter(el, done) {
      gsap.to(el, {
        opacity: 1,
        duration: 1,
        translateX: 0,
        onComplete: done,
      });
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.$nextTick(async () => {
      const notify = await this.habilitaNotificacoes();
      const notifyFalandoDeGente = await this.habilitaFalandoDeGente();

      if (notify) {
        this.existeNotificacao();
      }
      if(notifyFalandoDeGente) {
        this.existeFalandoDeGente();
      }
    });
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

@media all and (min-width: 300px) and (max-width: 1160px) {
  #nav-main {
    display: none;
  }
}

.nav-menu-show {
  transition: all 0.2s ease-in-out;
  background: #660099;
  box-shadow: 0px 15px 45px rgba(0, 0, 0, 0.35);
}

nav {
  width: 100%;
  padding: 10px 0px 0;

  .nav {
    width: 980px;
    margin: 0 auto;
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & .nav-holder {
      display: flex;
      align-items: center;

      .nav-icon {
        margin: 1em;
        width: 35px;
      }

      .nav-icon:after,
      .nav-icon:before,
      .nav-icon div {
        background-color: #fff;
        border-radius: 3px;
        content: '';
        display: block;
        height: 2px;
        margin: 7px 0;
        transition: all 0.2s ease-in-out;
      }

      .nav-icon-open:before {
        transform: translateY(9px) rotate(135deg);
      }

      .nav-icon-open:after {
        transform: translateY(-9px) rotate(-135deg);
      }

      .nav-icon-open div {
        transform: scale(0);
      }

      & .burger {
        background: linear-gradient(0deg, #461e5f 0%, #660099 100%), #461e5f;
        box-shadow: 0px 0px 30px rgba(255, 255, 255, 0.15);
        border-radius: 50%;
        border: 0;
        // border: 0px solid white;
        // border-radius: 5px;
        padding: 8px 12px 10px 12px;
        margin: 0 25px 0 5px;

        & svg {
          fill: white;
          margin: 0;
          -webkit-perspective: 50px;
        }

        & span {
          display: block;
          width: 22px;
          height: 2px;
          margin-bottom: 5px;
          position: relative;

          background: #cdcdcd;
          border-radius: 3px;

          z-index: 1;

          transform-origin: 4px 0px;

          transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
            background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;
        }
      }

      .logo {
        cursor: pointer;
      }
    }

    & .nav-options {
      display: flex;
      justify-content: center;
      align-items: center;
      & .item {
        margin-left: 5px;
        z-index: 2;
      }
    }
  }
}

.notify {
  position: relative;

  img {
    z-index: 1;
  }
  .dot {
    height: 6px;
    width: 6px;
    position: absolute;
    background: red;
    border-radius: 50%;
    right: 11px;
    top: 11px;

    &::before {
      content: '';
      height: 12px;
      width: 12px;
      position: absolute;
      background: red;
      border-radius: 50%;
      top: -3px;
      right: -3px;

      -webkit-animation: ping 1.4s ease-in-out infinite both;
      animation: ping 1.4s ease-in-out infinite both;
    }
  }
}

@-webkit-keyframes ping {
  0% {
    -webkit-transform: scale(0.2);
    transform: scale(0.2);
    opacity: 1;
  }
  80% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(2.2);
    transform: scale(2.2);
    opacity: 0;
  }
}
@keyframes ping {
  0% {
    -webkit-transform: scale(0.2);
    transform: scale(0.2);
    opacity: 1;
  }
  80% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(2.2);
    transform: scale(2.2);
    opacity: 0;
  }
}
</style>
